import { render, staticRenderFns } from "./ReservationMeetingspaces.vue?vue&type=template&id=a35efc4a&scoped=true"
import script from "./ReservationMeetingspaces.vue?vue&type=script&lang=js"
export * from "./ReservationMeetingspaces.vue?vue&type=script&lang=js"
import style0 from "./ReservationMeetingspaces.vue?vue&type=style&index=0&id=a35efc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35efc4a",
  null
  
)

export default component.exports